import React from 'react';
import { BygrProfileDetails, BygrProject } from 'types';
import { createDataTable } from 'components/DataTable';
import { CustomLink, DateDistanceDisplay } from '@ygtechnologies/bygr-frontend-component-library';
// import theme from './ProjectDetails.module.scss';

interface Props {
    profile: BygrProfileDetails;
    reloadProfile(): void;
}
const ProjectTable = createDataTable<BygrProject>();
const ProfileProjects: React.FC<Props> = ({ profile, reloadProfile }) => {
    return (
        <>
            <ProjectTable
                hasPagination={false}
                data={profile.projects}
                onStateChange={() => {}}
                state={ProjectTable.getInitialState('id')}
                totalItemCount={profile.projects.length}
                className="table style-3">
                <ProjectTable.Column
                    header="Name"
                    field="name"
                    renderer={({ row, value }) => <CustomLink to={`/projects/${row.id}`}>{value}</CustomLink>}
                />
                <ProjectTable.Column header="Units" field="numberOfUnits" />
                <ProjectTable.Column
                    header="Created"
                    field="createDate"
                    renderer={(x) => x.value && <DateDistanceDisplay value={x.value} />}
                />
            </ProjectTable>
        </>
    );
};

export default ProfileProjects;
